(function ($) {
    
    function arrowClicks(){
        $('.nav-menu a').on('click',function(e) {
            
            var href = $(this).attr('href');
            
            if (href === '#' && $(this).parent().hasClass('menu-item-has-children')){
                e.preventDefault();
                $( this ).siblings('.sub-menu').addClass('active');
                $( this ).closest('.menu-item').addClass('open');
                $( this ).parent().siblings('.menu-item').addClass('hidden');
            }
        });
        $('.nav-menu li .arrow').on('click',function(e) {
            e.preventDefault();
            $( this ).next().addClass('active');
            $( this ).closest('.menu-item').addClass('open');
            $( this ).parent().siblings('.menu-item').addClass('hidden');
            $( this ).closest('.sub-menu').addClass('parent');
        });
        $('.sidr__menu-back').on('click',function(){
            var menuCloseId = $( this ).data('sidr-menu');
            $( '#' + menuCloseId ).removeClass('active');
            $( '#' + menuCloseId ).parents('.sub-menu').removeClass('parent');
            $( this ).closest('.menu-item').removeClass('open');
            
            $( this ).parent().closest('.menu-item').siblings('.menu-item').removeClass('hidden');
        });
    }
    
    function stickyNav(){
        var $scrollTop = $(window).scrollTop();
        
		if ($scrollTop > 10) { 
			$('#masthead').addClass('sticky');
		} else {
			$('#masthead').removeClass('sticky');
		}
	};
    
    function initImageGalleries($scope) {
        $scope.find('.js-image-gallery').each(function() {
            var $gallery = $(this);

            // Prevent initializing the same gallery more than once
            if ($gallery.hasClass('gallery-initialized')) {
                return;
            }

            $gallery.addClass('gallery-initialized');

            // Init Masonry
            var $grid = $gallery.masonry({
                itemSelector: '.gallery-item',
                columnWidth: '.gallery-sizer',
                percentPosition: true,
                gutter: 20
            });

            // Layout Masonry after each image loads
            $grid.imagesLoaded().progress(function() {
                $grid.masonry('layout');
            });

            setTimeout(function() {
                $grid.masonry('layout');
            }, 100);

            // Init lightbox
            $gallery.slickLightbox({
                itemSelector: 'a',
                navigateByKeyboard: true
            });
        });
    }

	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: false,
            anchorPlacement: 'top-bottom'
        });
        
        /* Jarallax requirements */
        // object-fit polyfill run
        objectFitImages();

        // init Jarallax
        jarallax(document.querySelectorAll('.jarallax'), {
            disableParallax: /iPhone|iPod|Android/,
        });

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });
        
        
        $('#mobile-trigger').sidr({
            side: 'left',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu">';
                
                sidrHtml += '<div class="sidr__header">';
                sidrHtml += '<div class="sidr__logo"><a href="/"><img src="/wp-content/themes/cathey-strain-2026/assets/images/global/logo-full.svg" alt="Cathey & Strain" width="292" height="58"/></a></div>';
                sidrHtml += '<button class="sidr__close" aria-label="Close"></button>';
                sidrHtml += '</div>';
                
                sidrHtml += '<div class="sidr__inner">';
                sidrHtml += '<div class="sidr__mainnav">';
                sidrHtml += '<ul class="nav-menu">';
                    
                if($('.main-navigation').length){
                    sidrHtml += $('.main-navigation .nav-menu').html();
                }
                
                sidrHtml += '</ul>';
                sidrHtml += '</div>';
                
                if($('#site-header-contact').length){
                    sidrHtml += '<div class="sidr__subnav">';

                    var contactUrl = $('#site-header-contact').attr('href');
                    sidrHtml += '<a href="' + contactUrl + '" class="button button-primary-reverse" id="sidr__contact">' +  $('#site-header-contact').html() + '</a>';
                    
                    sidrHtml += '</div>';
                }
                
                sidrHtml += '</div>';
                sidrHtml += '</div>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                var headerHeight = $("#masthead").height(),
                    windowHeight = $(window).height();
                
                $('#masthead').addClass('mobile');
                
                $('.sidr__inner').find('.sub-menu').each(function() {
                    var menuId = $(this).parents('.menu-item').attr('id'),
                        parentLink = $(this).prevAll('a').attr('href'),
                        parentText = $(this).prevAll('a').html();
                    
                    $(this).attr('id','sidr-' + menuId).prepend('<li class="sidr__menu-back" data-sidr-menu="sidr-' + menuId + '"><span>' + parentText + '</span></li>');
                });
            },
            onOpenEnd: function(){
                arrowClicks();
            },
            onClose: function(){
                $('#masthead').removeClass('mobile');
            },
            onCloseEnd: function(){
                $('.sidr__inner').find('.sub-menu').each(function() {
                    $(this).find('.sidr__menu-back').remove();
                });
            }
        });
        
        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
            $('.nav-menu li .arrow').unbind();
            $('sidr__menu-back').unbind();
            stickyNav();
        });
        
        stickyNav();
        
        $( '.js-video-popup' ).magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
        $( '.js-modal-popup' ).magnificPopup({
            type: 'inline',
            preloader: false
        });
        
        initImageGalleries($(document));
        
	});
    
    $(document).on("mousedown touchstart",function(event){
        if($(event.target).closest('#sitesearch--toggle').length && $(event.target).is('#sitesearch--toggle')) {
            $('#sitesearch').addClass('active');
            $.sidr('close','sidr');
        }
        if($(event.target).closest('#mobile-search').length && $(event.target).is('#mobile-search')) {
            $('#sitesearch').addClass('active');
            $.sidr('close','sidr');
        }
        if($(event.target).closest('#sitesearch--close').length && $(event.target).is('#sitesearch--close')) {
            $('#sitesearch').removeClass('active');
        }
        if($(event.target).closest('#sitesearch.active').length && $(event.target).is('#sitesearch.active')) {
            $("#sitesearch").removeClass('active');
        } 
    });
    
    if (typeof acf !== 'undefined') {
        acf.addAction('render_block_preview', function($block) {
            initImageGalleries($block);
        });
    }
    

    let samt = 0;
    window.addEventListener('scroll', function() {
        samt <= 10 ? samt++ : AOS.refresh();
        samt <= 10 ? samt++ : stickyNav();
    });

    
})(jQuery);